// extracted by mini-css-extract-plugin
export default {"ticontainer":"styles_ticontainer__UJSYC","tiblock":"styles_tiblock__SbvlV","tidot":"styles_tidot__-yTPV","mercuryTypingAnimation":"styles_mercuryTypingAnimation__RCfUN"};